import axiosInstance from '../RestClient';

const BASE_URI = '/facturacion';

class FacturacionService {
	async getStatus() {
		const uri = `${BASE_URI}/status`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getSettings() {
		const uri = `${BASE_URI}/settings`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async updateSettings(payload) {
		const uri = `${BASE_URI}/settings`;
		const response = await axiosInstance.put(uri, payload);
		return response;
	}

	async getBalanceFacturacion(entityType, entityId, month) {
		const uri = `${BASE_URI}/balance/${entityType}/${entityId}/${month}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async previewFacturacion(entityType, entityId, month) {
		const uri = `${BASE_URI}/balance/${entityType}/${entityId}/${month}/preview`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async facturar(entityType, entityId, month) {
		const uri = `${BASE_URI}/balance/${entityType}/${entityId}/${month}/facturar`;
		const response = await axiosInstance.post(uri, {});
		return response;
	}

	async refreshComprobante(recordId) {
		const uri = `${BASE_URI}/comprobantes/${recordId}/refresh`;
		const response = await axiosInstance.post(uri, {});
		return response;
	}

	async downloadPdf(recordId) {
		const uri = `${BASE_URI}/comprobantes/${recordId}/pdf`;
		const response = await axiosInstance.get(uri, { responseType: 'blob' });
		return response;
	}
}

export default new FacturacionService();
